import { render, staticRenderFns } from "./StatusProyek.vue?vue&type=template&id=7025be2a"
import script from "./StatusProyek.vue?vue&type=script&lang=js"
export * from "./StatusProyek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports